//
//
//
//
//
//
//
//
//

import { isEmpty } from 'lodash';

export default {
  name: 'Favorites',
  data() {
    return {
      dataList: null,
      statusMenu: [
        { label: '全部', value: null },
        { label: '未申請', value: 0 },
        { label: '已申請', value: 1 },
      ],
      statusMenuActive: 0,
      status: null,
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.dataList);
    },
    filterData() {
      if (this.status !== null) {
        return this.dataList.filter(item => {
          return item.isJoin === this.status;
        });
      }
      return this.dataList;
    },
  },
  methods: {
    onStatusMenuClick(index, value) {
      this.status = value;
      this.statusMenuActive = index;
    },
    getCourse() {
      const payload = {};

      this.$api('getCourseCollect', payload).then(data => {
        this.dataList = data.records;
        this.current = data.current;
      });
    },
    onApply(courseId) {
      this.$api('addCourseJoin', { courseId }).then(data => {
        this.$message.success('申請成功!');
      });
    },
  },
  mounted() {
    this.getCourse();
  },
};
